"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fileToUrl = function (file) {
    var url = window.URL || window.webkitURL;
    try {
        return url.createObjectURL(file);
    }
    catch (e) {
        return '';
    }
};
exports.fileToUrl = fileToUrl;
var revokeUrl = function (objectUrl) {
    try {
        window.URL.revokeObjectURL(objectUrl);
    }
    catch (e) {
        // fail silently because they is no major disruption to user exp
    }
};
exports.revokeUrl = revokeUrl;
//# sourceMappingURL=objectUrlHelpers.js.map